import './style.scss';
import ConfirmWithIntl from 'app/components/ConfirmWithIntl';
import { useDeleteAttendingVeterinarianMutation } from 'app/queries/attendingVeterinariansQueries';
import React, { PropsWithChildren, memo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import { Icon, Modal } from 'semantic-ui-react';

type AttendingVeterinarianDeleteButtonProps = {
  name: string;
};

const AttendingVeterinarianDeleteButton = ({
  name,
  children,
}: PropsWithChildren<AttendingVeterinarianDeleteButtonProps>) => {
  const [open, setOpen] = useState(false);

  const { mutateAsync } = useDeleteAttendingVeterinarianMutation();

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };
  const handleConfirm = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    mutateAsync({ name }).catch(() => {
      toast.error(<FormattedMessage id="attendingVeterinarian.delete.error" values={{ name }} />);
    });
    setOpen(false);
  };
  const handleCancel = () => setOpen(false);

  return (
    <div className="attending-veterinarian-option">
      {children}
      <button
        type="button"
        onClick={handleButtonClick}
        className="attending-veterinarian-option__delete-button"
      >
        <Icon name="trash" />
      </button>
      <ConfirmWithIntl
        open={open}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        headerId="attendingVeterinarian.delete.header"
        content={
          <Modal.Content>
            <FormattedMessage id="attendingVeterinarian.delete.text" values={{ name }} />
          </Modal.Content>
        }
        dangerous
      />
    </div>
  );
};

export default memo(AttendingVeterinarianDeleteButton);
